import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, mergeMap, switchMap, take } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { defer, from, Observable, of } from 'rxjs';
import get from 'lodash-es/get';

import { OneIdService } from '@finder/shared/services/one-id/one-id.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Only update requests going to the detail API
        if (!req.url.includes('details-entity-simple')) {
            // No header changes required
            return next.handle(req);
        }

        // The OneID service comes back as a promise
        const oneIdServiceResolver: any = this.injector.get(OneIdService);

        // Convert promise to observable and get the guest data
        return defer(() => from(oneIdServiceResolver)).pipe(
            // We only want the first response
            // "take" will complete on error
            take(1),
            // We now have the OneID service. Get the guest info
            switchMap((oneIdService: OneIdService) => from(oneIdService.getGuest())),
            /**
             * The guest is more than likely not logged in. Return undefined
             * to mergeMap and finish
             */
            catchError(err => of(void 0)),
            mergeMap((guestData: any) => {
                if (!guestData) {
                    return next.handle(req);
                }

                /**
                 * If we have the id_token send that with the swid.
                 * If we don't send the refresh_token with the swid.
                 * Be careful of header size sent to the API
                 */
                const idToken = get(guestData, 'token.id_token');
                const refreshToken = get(guestData, 'token.refresh_token');
                if (idToken) {
                    req = req.clone({
                        setHeaders: {
                            'X-Disney-Internal-Id-Token': idToken,
                            'X-Disney-Internal-Swid': get(guestData, 'token.swid')
                        }
                    });
                } else if (refreshToken) {
                    req = req.clone({
                        setHeaders: {
                            'X-Disney-Internal-Refresh-Token': refreshToken,
                            'X-Disney-Internal-Swid': get(guestData, 'token.swid')
                        }
                    });
                }

                return next.handle(req);
            })
        );
    }
}
